<template>
  <ErrorLayout :title="'Whoops! An unexpected error occurred'">
    <p>
      Sorry, but an unexpected error has occurred, please contact <a
        class="underline text-royal-blue-100 hover:text-royal-blue-160 focus:text-royal-blue-160 visited:text-visited"
        href="mailto:RSC1@rsc.org?subject=OA%20Licencing%20System%20404%20Error">Customer Services</a> with a description of what you were trying to do and the following information.
    </p>
    <div>
      <ul class="list-none m-0 p-6 w-full mt-0 mb-0 ml-0 mr-0 pl-0">
        <!-- <li v-if="status"> -->
        <li>
          <span class="inline-block float-left font-bold max-w-[240px] align-middle w-[40%]">Server Response</span>
          <span class="inline-block align-middle w-[60%]">{{ status }}</span>
        </li>
        <li v-if="requestId">
          <span class="inline-block float-left font-bold max-w-[240px] align-middle w-[40%]">Correlation Id</span>
          <span class="inline-block align-middle w-[60%]">{{ requestId }}</span>
        </li>
      </ul>
    </div>
  </ErrorLayout>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { lastError } from '../../api/api-client'
import ErrorLayout from '@/layouts/ErrorLayout.vue'

const status = computed(() => {
  if (lastError.value && lastError.value.response) {
    const response = lastError.value.response
    return `${response.status} - ${response.statusText}`
  }
  return null
})

const requestId = computed(() => {
  if (lastError.value) {
    return lastError.value.response?.headers['x-correlation-id']
  }
  return null
})

</script>
